import { render, staticRenderFns } from "./WorkIconMinus.vue?vue&type=template&id=4114bb6b"
import script from "./WorkIconMinus.vue?vue&type=script&lang=js"
export * from "./WorkIconMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports